/**
 * Created by mac on 2019-06-17
 */

const MineSweeper = function (options) {
    BaseMiniGame.call(this);

    this.width = MineSweeper.WIDTH;
    this.height = MineSweeper.HEIGHT;
    this.cellsToOpen = this.width * this.height - MineSweeper.CONFIG.b;

    this.saver = options.saver;
};

MineSweeper.CONFIG = {
    b: 11,
    energy: 10,
    soft: 12,
    hard: 1
};

MineSweeper.prototype = Object.create(BaseMiniGame.prototype);
MineSweeper.prototype.constructor = MineSweeper;

MineSweeper.ELEMENT_OPENED = 0;
MineSweeper.ELEMENT_BOMB = "b";
MineSweeper.ELEMENT_OPENED_BOMB = "bo";
MineSweeper.ELEMENT_EXPLODED_BOMB = "be";
MineSweeper.ELEMENT_EMPTY = "e";
MineSweeper.ELEMENT_RUBY = "hard";
MineSweeper.ELEMENT_ENERGY = "energy";
MineSweeper.ELEMENT_COIN = "soft";
MineSweeper.ELEMENT_CHEST = "chest";

MineSweeper.WIDTH = 8;
MineSweeper.HEIGHT = 7;

MineSweeper.REPLAY_PRICE = 20;

MineSweeper.prototype.generateField = function (col, row) {
    this.reward = {};
    this.board = [];
    this.bombs = [];
    this.prizes = [];
    let i, j;

    const inFreeArea = function (r, c) {
        return Math.abs(r - row) <= 1 && Math.abs(c - col) <= 1;
    };

    const generate = function (config, cellNumb) {
        let items = [];
        for (const type in config) {
            for (let i = 0; i < config[type]; i++) {
                if (items.length < cellNumb) {
                    items.push(type);
                }
            }
        }

        while (items.length < cellNumb) {
            items.push(MineSweeper.ELEMENT_EMPTY);
        }

        PseudoRandom.GET().randomSeed();
        items = PseudoRandom.GET().shuffle(items);

        return items;
    };

    let freeAreaSize = 0;
    for (i = 0; i < this.height; i++) {
        for (j = 0; j < this.width; j++) {
            if (inFreeArea(i, j)) {
                freeAreaSize++;
            }
        }
    }

    const notFreeItems = generate(MineSweeper.CONFIG, this.width * this.height - freeAreaSize);
    this.board = [];
    for (i = 0; i < this.height; i++) {
        this.board.push([]);
        for (j = 0; j < this.width; j++) {
            if (inFreeArea(i, j)) {
                this.board[i].push(MineSweeper.ELEMENT_EMPTY);
                continue;
            }
            const elem = notFreeItems.pop();
            this.board[i].push(elem);
            if (elem === MineSweeper.ELEMENT_BOMB) {
                this.bombs.push({ col: j, row: i });
            } else if ([MineSweeper.ELEMENT_RUBY, MineSweeper.ELEMENT_ENERGY, MineSweeper.ELEMENT_COIN].indexOf(elem) !== -1) {
                this.prizes.push({ col: j, row: i });
            }
        }
    }

    this.cellsToOpen = this.width * this.height - this.bombs.length;
    this.trigger("cellsToOpen", this.cellsToOpen);
};

MineSweeper.prototype.initFlags = function () {
    this.flags = [];
    for (let i = 0; i < this.height; i++) {
        this.flags.push([]);
        for (let j = 0; j < this.width; j++) {
            this.flags[i].push(false);
        }
    }
};

MineSweeper.prototype.hasElement = function (col, row) {
    if (row < 0 || col < 0 || row >= this.height || col >= this.width) {
        return false;
    }
    if (!this.board) {
        return true;
    }
    return this.board[row][col] !== MineSweeper.ELEMENT_OPENED && this.board[row][col] !== MineSweeper.ELEMENT_OPENED_BOMB && this.board[row][col] !== MineSweeper.ELEMENT_EXPLODED_BOMB;
};

MineSweeper.prototype.getPrizeValue = function (type) {
    if (type === MineSweeper.ELEMENT_ENERGY || type === MineSweeper.ELEMENT_COIN) {
        return PseudoRandom.GET().random(1, 2);
    }
    return 1;
};

MineSweeper.prototype.openField = function () {
    this.trigger("openField");

    for (let i = 0; i < this.height; i++) {
        for (let j = 0; j < this.width; j++) {
            if (this.flags[i][j]) {
                this.trigger("removeFlag", { row: i, col: j, silent: true });
                this.flags[i][j] = false;
            }
        }
    }

    this.prizes.forEach((prize) => {
        if (this.board[prize.row][prize.col] !== MineSweeper.ELEMENT_OPENED) {
            this.trigger("showPrize", {
                col: prize.col,
                row: prize.row,
                prize: { type: this.board[prize.row][prize.col] }
            });
        }
    });

    this.bombs.forEach((bomb) => {
        if (this.board[bomb.row][bomb.col] !== MineSweeper.ELEMENT_OPENED_BOMB) {
            this.trigger("showBomb", {
                col: bomb.col,
                row: bomb.row
            });
        }
    });
};

MineSweeper.prototype.win = function (col, row) {
    if (!this.board) {
        this.generateField(0, 0);
    }
    if (!this.flags) {
        this.initFlags();
    }
    this.openField();

    if (typeof UnitsLibraryHelper !== "undefined") {
        this.reward.units = [UnitsLibraryHelper.ResolveUnit({ type: "reschest", stage: 0, amount: 1 })];

        if (col !== undefined) {
            this.trigger("prize", {
                col,
                row,
                prize: { type: MineSweeper.ELEMENT_CHEST, amount: 1 }
            });
        }
    }

    this.saver.add({ reward: this.reward });

    this.trigger("win");
    this.finish();
    setTimeout(() => {
        this.trigger("victory");
    }, 1000);
};

MineSweeper.prototype.lose = function (f, options) {
    cleverapps.audio.fadeOutAndEject();

    cleverapps.focusManager.compound(f, [
        function (f) {
            this.trigger("bomb", options);

            cleverapps.timeouts.setTimeout(f, 1000);
        }.bind(this),

        function (f) {
            this.explode(options);

            cleverapps.timeouts.setTimeout(f, 1000);
        }.bind(this),

        function (f) {
            if (cleverapps.platformLogic.reportGameOver) {
                cleverapps.platformLogic.reportGameOver();
            }
            f();
        },

        function (f) {
            this.trigger("lose", f);
        }.bind(this)
    ]);
};

MineSweeper.prototype.explode = function (options) {
    this.board[options.row][options.col] = MineSweeper.ELEMENT_EXPLODED_BOMB;

    for (const type in this.reward) {
        const newValue = Math.floor(this.reward[type] * (0.3 + 0.2 * Math.random()));
        const delta = newValue - this.reward[type];

        if (newValue) {
            this.reward[type] = newValue;
        } else {
            delete this.reward[type];
        }

        this.trigger("explodePrize", {
            type,
            amount: delta
        });
    }

    this.saver.add({ reward: this.reward });

    this.openField();
};

MineSweeper.prototype.switchFlag = function (col, row) {
    if (row < 0 || col < 0 || row >= this.height || col >= this.width) {
        return;
    }

    if (this.board) {
        if (this.board[row][col] === MineSweeper.ELEMENT_OPENED || this.board[row][col] === MineSweeper.ELEMENT_OPENED_BOMB || this.board[row][col] === MineSweeper.ELEMENT_EXPLODED_BOMB) {
            return;
        }
    }

    if (!this.flags) {
        this.initFlags();
    }

    if (this.flags[row][col]) {
        this.trigger("removeFlag", { row, col });
        this.flags[row][col] = false;
    } else {
        this.trigger("addFlag", { row, col });
        this.flags[row][col] = true;
    }
};

MineSweeper.prototype.open = function (col, row) {
    if (row < 0 || col < 0 || row >= this.height || col >= this.width) {
        return;
    }

    if (!this.board) {
        this.generateField(col, row);
        cleverapps.eventBus.trigger("taskEvent", "PLAY_MINESWEEPER");
    }

    if (this.board[row][col] === MineSweeper.ELEMENT_OPENED || this.board[row][col] === MineSweeper.ELEMENT_OPENED_BOMB || this.board[row][col] === MineSweeper.ELEMENT_EXPLODED_BOMB) {
        return;
    }

    if (!this.flags) {
        this.initFlags();
    }

    if (this.flags[row][col]) {
        return;
    }

    if (this.board[row][col] === MineSweeper.ELEMENT_BOMB) {
        this.board[row][col] = MineSweeper.ELEMENT_OPENED_BOMB;
        this.pause();
        this.trigger("open", { row, col, bomb: true });
        this.trigger("askContinue", { row, col });
        return;
    }

    const value = this.board[row][col];
    this.board[row][col] = MineSweeper.ELEMENT_OPENED;
    const bombs = this.countBombsNearby(col, row);
    const options = {
        row,
        col,
        bombs
    };
    this.cellsToOpen--;
    this.trigger("cellsToOpen", this.cellsToOpen);

    this.trigger("open", options);
    if (!bombs) {
        this.open(col - 1, row - 1);
        this.open(col, row - 1);
        this.open(col + 1, row - 1);
        this.open(col - 1, row);
        this.open(col + 1, row);
        this.open(col - 1, row + 1);
        this.open(col, row + 1);
        this.open(col + 1, row + 1);
    }

    if ([MineSweeper.ELEMENT_RUBY, MineSweeper.ELEMENT_ENERGY, MineSweeper.ELEMENT_COIN].indexOf(value) !== -1) {
        const rewardAmount = this.getPrizeValue(value);
        this.trigger("prize", {
            col,
            row,
            prize: { type: value, amount: rewardAmount }
        });

        this.reward[value] = (this.reward[value] || 0) + rewardAmount;
    }

    if (this.isFinished()) {
        this.win(col, row);
    }
};

MineSweeper.prototype.listNearby = function (col, row) {
    const near = [];
    for (let i = col - 1; i <= col + 1; i++) {
        if (i >= 0 && i < this.width) {
            for (let j = row - 1; j <= row + 1; j++) {
                if (j >= 0 && j < this.height) {
                    if (this.board[j][i] !== MineSweeper.ELEMENT_OPENED) {
                        near.push({
                            row: j,
                            col: i
                        });
                    }
                }
            }
        }
    }
    return near;
};

MineSweeper.prototype.countBombsNearby = function (col, row) {
    return this.listNearby(col, row).filter((pos) => [MineSweeper.ELEMENT_BOMB, MineSweeper.ELEMENT_OPENED_BOMB, MineSweeper.ELEMENT_EXPLODED_BOMB].includes(this.board[pos.row][pos.col])).length;
};

MineSweeper.prototype.isFinished = function () {
    return this.cellsToOpen === 0;
};